module.exports = __webpack_public_path__ + "img/closed-captioning-slash.0c857aa9.svg";